<template>
  <v-app>
    <!-- <v-app-bar app color="white">
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />
        <router-link to="/">
          <span class="primary--text font-weight-bold title logo">Econodata</span>
        </router-link>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="http://econodata.com.br"
        target="_blank"
        text
        color="primary"
      >
        <span class="mr-2">links aqui</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>-->
    <v-container class="pl-0 pl-md-10">
      <v-row class="ml-0 pl-0 ml-sm-5 ml-md-10 pl-md-10">
        <nav class="ml-0 ml-sm-5 ml-md-10">
          <v-col no-guuters class="d-flex align-center">
            <a href="https://www.agendor.com.br/" target="_blank" style="display: inline-block" class="nav-logo" rel="external nofollow">
              <img src="https://cdn.prod.website-files.com/623201a0da52900bfc863055/6410cd40b5fdaf5bac1f1174_logo-agendor.svg" alt="agendor" />
            </a>
            <div class="ml-0 ml-md-3" style="font-size: 26px">
              /
            </div>
            <a
              href="https://www.econodata.com.br"
              target="_blank"
              style="display: inline-block; margin-top: -6px;"
              class="ml-1"
            >
              <img :src="LogoEconodata" alt="Econodata" class="nav-logo"  />
            </a>
          </v-col>
        </nav>
      </v-row>
    </v-container>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import LogoEconodata from './assets/logoecdt.png';

export default {
  name: 'App',

  data: () => ({
    LogoEconodata: LogoEconodata
  })
};
</script>
<style scoped>
.nav-logo {
  max-width: 165px;
}

@media only screen and (min-width: 576px) {
  .nav-logo {
    max-width: 190px;
  }
}
</style>
